module.exports = "/_next/static/images/062115a3a03fe6e1e8835a5d53018e4d-hero-small.jpg.webp";